import { DropdownWrapper } from "components";
import { type AutocompleteAccount } from "interfaces/Account";
import React, { useMemo } from "react";
import { useGetAutocompleteQuery } from "../state/api/createAccountApi";
import { useThrottledValue } from "hooks/useThrottledValue";

const mapOptions = (accounts: AutocompleteAccount[]) => {
  return accounts.map((account) => {
    return {
      text: account.name,
      value: account.id,
      content: account.isNew ? `${account.name} (New Account)` : account.name,
      data: account,
    };
  });
};

interface Props {
  onAccountSelected: (acc: { name: string; id: number; isNew?: boolean; logoUri: string }) => void;
}

export const AccountName = (props: Props) => {
  const { onAccountSelected } = props;
  const [search, setSearch] = React.useState<string>("");
  const throttledSearch = useThrottledValue(search);

  const isSearchEmpty = search.length === 0;

  const { data: accounts } = useGetAutocompleteQuery(throttledSearch, { skip: isSearchEmpty });

  const options = useMemo(() => {
    return accounts && !isSearchEmpty ? mapOptions(accounts) : [];
  }, [accounts, isSearchEmpty]);

  return (
    <DropdownWrapper
      options={options}
      selection
      blur
      fluid
      lazyLoad
      clearable
      direction="right"
      placeholder="Select Company or Create New"
      search={(options) => {
        return options;
      }}
      handleOptionChange={(_, data) => {
        const selected = options.find((opt) => opt.value === data.value);
        selected && onAccountSelected({ ...selected.data });
      }}
      onSearchChange={(_, data) => {
        setSearch(data.searchQuery);
      }}
      noResultsMessage={null}
    />
  );
};
